(ns common.schema.entities.task.core
  (:require [common.entity-ownership :as entity-ownership]
            [common.roles :as roles]
            [common.schema.entities.task :as task]))

;; Verbatim copy of common.schema.entity-types's existing task entry
;; (entity_types.cljc around line 1223-1243, using owner-admin-check-fn
;; defined around line 316 there) - required here, not there, to avoid a
;; circular namespace dependency (entity_types.cljc requires this
;; registry). Keep in sync if the originals ever change.
;;
;; The read check is a literal tenant-name comparison, not a feature/module
;; flag - a one-off restriction for the "CapMan" tenant specifically, not a
;; generalizable pattern. Preserved as-is rather than "fixed" into something
;; more generic.
(defn- read-permissions-check-fn
  [{:keys [account tenant entity]}]
  (or (not (= "CapMan" (:tenant/name tenant)))
      (= (:db/id account)
         (->> entity
              :task/assignee
              :db/id))))

(defn- owner-admin-check-fn
  [{:keys [role account entity]}]
  (when (:db/id account)
    (or (roles/admin? role)
        (entity-ownership/entity-owner? account entity))))

(defn- disable-permissions-check-fn
  [{:keys [tr entity account] :as ctx}]
  (when-not (or (owner-admin-check-fn ctx)
                (->> entity
                     :task/assignee
                     :db/id
                     (= (:db/id account)))
                (->> entity
                     :common/team-members
                     (map :db/id)
                     (some #{(:db/id account)})))
    (tr :only-admin-or-assignee-can-delete-tasks)))

(def entity-type-definition
  {:entity-type                  :entity.type/task
   :schema                       task/schema
   :name                         {:en "Task"}
   :plural                       {:en "Tasks"}
   :icon                         :fa-tasks
   :read-permissions-check-fn    read-permissions-check-fn
   :disable-permissions-check-fn disable-permissions-check-fn

   ;; task has no pre-existing legacy dedicated OpenSearch index - it does
   ;; not even flow through the universal/omnibox indexer today (its
   ;; common.opensearch.entity-indices entry is an empty map, and it has no
   ;; entry at all in backend.search.entity-indices). Leaving :search-index?
   ;; unset lets it default to true (since :search is present below),
   ;; routing dedicated indexing through the newer
   ;; backend.search.dedicated.indexes/init! bootstrap - the index is
   ;; created and re-indexed explicitly as part of this port, matching
   ;; contract-kyc-profile/tenant-kyc-profile/zap-vault's ports (see
   ;; ai/mistakes.md).
   ;;
   ;; :task/title is only meaningfully populated for :task.type/simple tasks
   ;; (webentry/email tasks show blank here) - a deliberate simplification
   ;; per the port's scope: all task types are imported into one uniform
   ;; listing with one uniform column set, and users filter/distinguish by
   ;; :task/type themselves via the generic listing's own filter panel,
   ;; rather than reproducing the legacy grid's per-type tabs/columns.
   :search                       {:result/title-attr :task/title
                                  :list/default-columns [:task/assignee
                                                         :task/due
                                                         :common/created-on
                                                         :task/completed?
                                                         :task/title
                                                         :task/message]
                                  :views {:grid {:po-default-field-paths [[:task/assignee]
                                                                          [:task/due]
                                                                          [:common/created-on]
                                                                          [:task/completed?]
                                                                          [:task/title]
                                                                          [:task/message]]
                                                 :mandatory-field-paths []}}}})
